<template>
  <div class="min-h-screen">
    <!-- 顶部导航栏 -->
    <header class="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div class="px-4 py-3 bg-gradient-to-r from-blue-50 to-blue-100 flex items-center">
        <a @click="$router.back()" class="text-gray-600 hover:text-blue-500 transition-colors">
          <!-- <font-awesome-icon icon="arrow-left" class="text-xl" /> -->
        </a>
        <h1 class="text-lg font-semibold text-center flex-1">附近医院</h1>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="pt-16">
      <!-- 搜索栏 -->
      <div class="px-4 py-3">
        <div class="relative">
          <input 
            v-model="searchText"
            type="text" 
            placeholder="搜索医院名称、地址..." 
            class="w-full pl-10 pr-4 py-3 bg-white rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-200 shadow-sm transition-all"
            @input="onSearch"
          >
          <font-awesome-icon icon="search" class="absolute left-4 top-1/2 transform -translate-y-1/2 text-blue-400" />
        </div>
      </div>

      <!-- 地图 -->
      <div class="px-4 mt-4">
        <div id="map" ref="map"></div>
      </div>

      <!-- 医院列表 -->
      <div class="hospital-list mt-4 px-4 space-y-3">
        <!-- 医院卡片 -->
        <div 
          v-for="hospital in filteredHospitals" 
          :key="hospital.id"
          class="hospital-card bg-gradient-to-br from-white to-blue-50 p-4 rounded-2xl shadow-sm"
        >
          <div class="flex justify-between items-start">
            <div class="flex-1">
              <h3 class="font-medium text-gray-800">{{ hospital.name }}</h3>
              <p class="text-sm text-gray-500 mt-1" style="display: flex;">
                <img style="width: 17px;height: 17px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/SelPosition.png"/>
                <!-- <font-awesome-icon icon="map-marker-alt" class="text-blue-500 mr-1" /> -->
                {{ hospital.address }}
                <span class="text-blue-500 font-medium ml-2">{{ hospital.distance }}km</span>
              </p>
              <div class="flex flex-wrap gap-2 mt-2">
                <span 
                  v-for="(tag, index) in hospital.tags" 
                  :key="index"
                  class="badge badge-specialty"
                >
                  {{ tag }}
                </span>
              </div>
              <div class="flex items-center gap-4 mt-3 text-sm text-gray-600">
                <!-- <span> -->
                  <!-- <font-awesome-icon icon="clock" class="mr-1" /> -->
                  <img style="width: 17px;height: 17px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/clock-filling.png"/>
                  {{ hospital.openStatus }}
                <!-- </span> -->
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <button 
                class="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-5 py-2 rounded-xl text-sm hover:from-blue-600 hover:to-blue-700 transition-all flex items-center justify-center"
                @click="startChat(hospital)"
              >
                <img style="width: 15px;height: 15px;" class="mr-1" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/comments.png"/>
                <!-- <font-awesome-icon icon="comments" class="mr-1" /> -->
                咨询
              </button>
              <button 
                class="bg-white text-blue-500 border border-blue-200 px-5 py-2 rounded-xl text-sm hover:bg-blue-50 transition-all flex items-center justify-center"
                @click="startNavigation(hospital)"
              >
                <img style="width: 17px;height: 17px;" class="mr-1" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/location-arrow.png"/>
                <!-- <font-awesome-icon icon="location-arrow" class="mr-1" /> -->
                导航
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
// 引入 Leaflet 库
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

export default {
  name: 'Hospitals',
  data() {
    return {
      searchText: '',
      loading: false,
      refreshing: false,
      map: null,
      markers: [],
      currentLocation: null,
      hospitals: [
        {
          id: '1',
          name: '爱宠动物医院',
          rating: 4.8,
          distance: 0.5,
          address: '北京市朝阳区三里屯街道123号',
          phone: '010-12345678',
          tags: ['骨科', '内科', '皮肤科'],
          openStatus: '营业中 08:00-22:00',
          latitude: 39.9042,
          longitude: 116.4074
        },
        {
          id: '2',
          name: '康康宠物医院',
          rating: 4.5,
          distance: 0.8,
          address: '北京市朝阳区工体北路甲2号',
          phone: '010-87654321',
          tags: ['外科', '眼科', '疫苗接种'],
          openStatus: '营业中 09:00-20:00',
          latitude: 39.9052,
          longitude: 116.4084
        },
        {
          id: '3',
          name: '瑞鹏宠物医院',
          rating: 4.2,
          distance: 1.2,
          address: '北京市朝阳区东三环北路丙2号',
          phone: '010-11112222',
          tags: ['影像科', '手术中心', '美容服务'],
          openStatus: '24小时营业',
          latitude: 39.9062,
          longitude: 116.4094
        }
      ]
    }
  },
  computed: {
    filteredHospitals() {
      if (!this.searchText) {
        return this.hospitals;
      }
      
      const searchLower = this.searchText.toLowerCase();
      return this.hospitals.filter(hospital => 
        hospital.name.toLowerCase().includes(searchLower) || 
        hospital.address.toLowerCase().includes(searchLower) ||
        hospital.tags.some(tag => tag.toLowerCase().includes(searchLower))
      );
    }
  },
  methods: {
    initMap() {
      // 初始化地图
      this.map = L.map(this.$refs.map).setView([39.9042, 116.4074], 14);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);
      
      // 添加医院标记
      this.addHospitalMarkers();
    },
    
    addHospitalMarkers() {
      if (!this.map) return;
      
      // 清除现有标记
      this.markers.forEach(marker => this.map.removeLayer(marker));
      this.markers = [];
      
      // 添加新标记
      this.hospitals.forEach(hospital => {
        const marker = L.marker([hospital.latitude, hospital.longitude]).addTo(this.map);
        marker.bindPopup(`
          <div class="text-center p-2">
            <h3 class="font-medium text-gray-800">${hospital.name}</h3>
            <div class="text-sm text-blue-500 mt-1">
              ${hospital.tags.join(' · ')}
            </div>
            <button onclick="window.dispatchEvent(new CustomEvent('hospital-navigation', {detail: {id: '${hospital.id}'}}));" class="mt-2 bg-white text-blue-500 border border-blue-200 px-3 py-1 rounded-lg text-sm hover:bg-blue-50 transition-all">
              <i class="fas fa-location-arrow mr-1"></i>导航
            </button>
          </div>
        `);
        this.markers.push(marker);
      });
    },
    
    async refreshLocation() {
      this.refreshing = true;
      
      try {
        // 模拟获取位置
        this.currentLocation = {
          latitude: 39.9042,
          longitude: 116.4074
        };
        
        if (this.map) {
          this.map.setView([this.currentLocation.latitude, this.currentLocation.longitude], 14);
        }
      } catch (error) {
        console.error('获取位置失败', error);
      } finally {
        this.refreshing = false;
      }
    },
    
    onSearch() {
      // 搜索时更新地图标记
      this.addHospitalMarkers();
    },
    
    makeCall(phone) {
      window.location.href = `tel:${phone}`;
    },
    
    startNavigation(hospital) {
      // 在实际应用中，这里可以调用地图应用进行导航
      window.open(`https://maps.google.com/maps?daddr=${hospital.latitude},${hospital.longitude}`, '_blank');
    },
    
    startChat(hospital) {
      this.$router.push({
        path: '/chat',
        query: { hospitalId: hospital.id }
      });
    }
  },
  mounted() {
    this.initMap();
    
    // 监听地图标记点击事件
    window.addEventListener('hospital-navigation', (event) => {
      const hospital = this.hospitals.find(h => h.id === event.detail.id);
      if (hospital) {
        this.startNavigation(hospital);
      }
    });
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('hospital-navigation', () => {});
  }
}
</script>

<style scoped>
:root {
  --primary-color: #3B82F6;
  --secondary-color: #93C5FD;
  --accent-color: #2563EB;
  --background-color: #F3F4F6;
}

body {
  background-color: var(--background-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

#map {
  width: 100%;
  height: 300px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.hospital-list {
  height: calc(100vh - 480px);
  overflow-y: auto;
}

.hospital-list::-webkit-scrollbar {
  width: 6px;
}

.hospital-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.hospital-list::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.hospital-list::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}

.hospital-card {
  transition: all 0.3s ease;
}

.hospital-card:hover {
  transform: translateY(-2px);
}

.badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.badge-specialty {
  background-color: #E0E7FF;
  color: #4F46E5;
}
</style> 